import PageContent from './components/PageContent'

const Auctions = () => (
  <PageContent />
)

export default Auctions
